import api from '@shared/api';

import {
    DictionarySearchResponse,
    JobExecutionSearchPayload,
    JobExecutionSearchResponse,
} from './types';

const JOBS_PATH = 'dda/api/v1';

export const fetchJobExecutions = async (payload: JobExecutionSearchPayload) =>
    (await api.post<JobExecutionSearchResponse>(`${JOBS_PATH}/job_execution/search`, payload)).data;

export const fetchJobExecutionStatuses = async () =>
    (
        await api.post<DictionarySearchResponse>(`${JOBS_PATH}/dict_job_execution_status/search`, {
            page: {page: 0, size: 10000},
        })
    ).data;
